import { render, staticRenderFns } from "./pubpayment.vue?vue&type=template&id=73bd3fa2&scoped=true&"
import script from "./pubpayment.vue?vue&type=script&lang=js&"
export * from "./pubpayment.vue?vue&type=script&lang=js&"
import style0 from "./pubpayment.vue?vue&type=style&index=0&id=73bd3fa2&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd3fa2",
  null
  
)

export default component.exports